const QUICK_REPLY_MARKER = '|quickReply|';
const BLINKING_CURSOR = '<span class="blinking-cursor" style="">|</span>';

function extractJsonArrayText(input) {
  const startIndex = input.indexOf('[');
  if (startIndex === -1) {
    return null;
  }

  let depth = 0;
  let inString = false;
  let escaping = false;

  for (let index = startIndex; index < input.length; index += 1) {
    const char = input[index];

    if (escaping) {
      escaping = false;
      continue;
    }

    if (char === '\\') {
      escaping = inString;
      continue;
    }

    if (char === '"') {
      inString = !inString;
      continue;
    }

    if (inString) {
      continue;
    }

    if (char === '[') {
      depth += 1;
    } else if (char === ']') {
      depth -= 1;
      if (depth === 0) {
        return input.slice(startIndex, index + 1);
      }
    }
  }

  return null;
}

export function parseQuickReplyMessage(message) {
  const originalText = message == null ? '' : String(message);
  const markerIndex = originalText.indexOf(QUICK_REPLY_MARKER);

  if (markerIndex === -1) {
    return {
      text: originalText,
      quickReplies: [],
      hasQuickReplies: false,
    };
  }

  const messageWithoutCursor = originalText.replaceAll(BLINKING_CURSOR, '');
  const safeMarkerIndex = messageWithoutCursor.indexOf(QUICK_REPLY_MARKER);
  const replyJsonText = extractJsonArrayText(
    messageWithoutCursor.slice(safeMarkerIndex + QUICK_REPLY_MARKER.length)
  );

  if (replyJsonText == null) {
    return {
      text: originalText,
      quickReplies: [],
      hasQuickReplies: false,
    };
  }

  try {
    const parsedReplies = JSON.parse(replyJsonText);
    const quickReplies = Array.isArray(parsedReplies)
      ? parsedReplies
        .filter((reply) => typeof reply === 'string' && reply.trim().length > 0)
        .map((reply) => reply.trim())
      : [];

    if (quickReplies.length === 0) {
      // Empty marker (e.g. `|quickReply|[]`): the model successfully signalled
      // "no quick replies", so strip the marker from the visible text — capture
      // it but never render the raw `|quickReply|[]` token or any bubbles.
      return {
        text: messageWithoutCursor.slice(0, safeMarkerIndex).trimEnd(),
        quickReplies: [],
        hasQuickReplies: false,
      };
    }

    return {
      text: messageWithoutCursor.slice(0, safeMarkerIndex).trimEnd(),
      quickReplies,
      hasQuickReplies: true,
    };
  } catch {
    return {
      text: originalText,
      quickReplies: [],
      hasQuickReplies: false,
    };
  }
}

export function hasQuickReplyMarker(message) {
  return (message == null ? '' : String(message)).indexOf(QUICK_REPLY_MARKER) !== -1;
}

export function isLatestQuickReplyMessage(messages, index) {
  if (!Array.isArray(messages) || index !== messages.length - 1) {
    return false;
  }

  const message = messages[index];
  return parseQuickReplyMessage(message?.messageBot).quickReplies.length > 0;
}

export function shouldShowQuickReplyMessage(messages, index, consumedMessage = null) {
  if (!isLatestQuickReplyMessage(messages, index)) {
    return false;
  }

  return messages[index] !== consumedMessage;
}

export function getQuickReplyMarker() {
  return QUICK_REPLY_MARKER;
}

export function getBlinkingCursorMarkup() {
  return BLINKING_CURSOR;
}

export default parseQuickReplyMessage;
